import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { TabView, TabPanel } from 'primereact/tabview';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import { Panel } from 'primereact/panel';
import { Dropdown } from "primereact/dropdown";
import { Button } from 'primereact/button';

import {
  Form as initForm,
  pesquisarAll,
  salvar,
  pesquisarNomeCPF,
  buscarPerfisdeAcesso,
  buscarPerfisdeAcessoUsuario,
  buscarVinculoAndPerfil,
  alterarPerfilUsuario
} from "../../service/Seguranca/usuario";
import { printToast, summaryCriacaoSucessoPadrao, detailCriacaoSucessoPadrao, summaryAlteracaoSucessoPadrao, detailAlteracaoSucessoPadrao } from "../../config/global";

import './style.css';

import TableSeplag from "../../components/TableSeplag";
import CardSeplag from "../../components/CardSeplag";
import RotuloSeplag from "../../components/RotuloSeplag";
import ModalSeplag from "../../components/ModalSeplag";



const Index = () => {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(initForm);
  const [ListaUsuario, setListaUsuario] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [perfisdeAcesso, setPerfisdeAcesso] = useState([]);
  const [perfilSelect, setPerfilSelect] = useState(null);
  const [cDadosVinculos, setCDadosVinculos] = useState([]);
  const [vinculoSelecionado, setVinculoSelecionado] = useState([]);

  const camposTabela = [
    { titulo: "Nome", nome: "pessoa.nomePessoa" },
    { titulo: "E-mail", nome: "pessoa.descEmail" },
    { titulo: "CPF", nome: "pessoa.cpfFormatado" },
    { titulo: "Matrícula", nome: "pessoa.servidor.numrMatricula" },
  ];

  const camposTabelaVinculo = [
    { nome: "numrVinculo", titulo: "Nº" },
    { nome: "orgao.descOrgao", titulo: "Órgão" },
    { nome: "unidade.descUnidade", titulo: "Unidade" },
    { nome: "tipoVinculo.descTipoVinculo", titulo: "Tipo" },
    { nome: "statVinculo", titulo: "Status" },
    { nome: "nomePerfilAcesso", titulo: "Nome" }
  ]

  useEffect(() => {
    let filtro = `?size=10&page=0`;

    pesquisarAll(filtro).then((res) => {
      setListaUsuario(res.content);
      setTotalRecords(res.totalElements);
      buscarPerfisdeAcesso().then((res) => {
        setPerfisdeAcesso(res)
      });
    });

  }, []);

  useEffect(() => {

    if (form.pessoa.idenPessoa) {
      buscarVinculoAndPerfil(form.pessoa.idenPessoa).then(res => {
        setCDadosVinculos(res)
      })
    }

  }, [form])


  const onEditarDado = (data) => {
    buscarPerfisdeAcessoUsuario(data).then((res) => {
      let auxPerfil = [];
      if (res.length > 0) {
        for (let i = 0; i < res.length; i++) {
          auxPerfil.push({
            contaAcesso: data.id,
            perfilAcesso: res[i]
          })
        }
      }
      setForm({
        id: data.id,
        nomeApresentacao: data.pessoa.nomePessoa ? data.pessoa.nomePessoa : '',
        login: data.login ? data.login : '',
        ativoConta: "S",
        pessoa: {
          idenPessoa: data.pessoa.idenPessoa,
          nomePessoa: data.pessoa.nomePessoa ? data.pessoa.nomePessoa : '',
          descEmail: data.pessoa.descEmail ? data.pessoa.descEmail : '',
          numrCpf: data.pessoa.numrCpf.replace(/^([\d]{3})([\d]{3})([\d]{3})([\d]{2})$/, "$1.$2.$3-$4"),
          numrTelefonePessoal: data.pessoa.numrTelefonePessoal ? data.pessoa.numrTelefonePessoal : '',
          numrTelefoneCelular: data.pessoa.numrTelefoneCelular ? data.pessoa.numrTelefoneCelular : '',
          dataNascimento: data.pessoa.dataNascimento,
          flagSexo: data.pessoa.flagSexo,
          endrTipoLogradouro: data.pessoa.endrTipoLogradouro,
          endrLogradouro: data.pessoa.endrLogradouro,
          endrBairro: data.pessoa.endrBairro,
          endrComplemento: data.pessoa.endrComplemento,
          numrCep: data.pessoa.numrCep,
          endrNumero: data.pessoa.endrNumero
        },
        perfis: auxPerfil,
        matricula: data.pessoa.servidor ? data.pessoa.servidor.numrMatricula : "Não Possui - Empregado Público"
      });
      setShowForm(true);
    })
  };


  const onBuscaPorNomeCPF = (inputValue) => {
    pesquisarNomeCPF(inputValue).then((res) => {
      setListaUsuario(res.content);
      setTotalRecords(res.totalElements);
    });
  };



  const onFecharModal = () => {
    setShowForm(false);
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: form,
    onSubmit: async (data) => {
      await salvar(data).then((res) => {
        pesquisarAll().then((res) => {
          setListaUsuario(res.content);
          setTotalRecords(res.totalElements);
        });

        let summary;
        let detail;

        if (res.type === "INS") {
          summary = summaryCriacaoSucessoPadrao;
          detail = detailCriacaoSucessoPadrao;
        } else {
          summary = summaryAlteracaoSucessoPadrao;
          detail = detailAlteracaoSucessoPadrao;
        }
        printToast({ summary, detail });
        setShowForm(false);
      });
    },
  });

  const paginacao = (event) => {
    let filtro = `?size=${event.rows}&page=${event.page}`;
    pesquisarAll(filtro).then((res) => {
      setListaUsuario(res.content);
      setTotalRecords(res.totalElements);
    });
  };


  const vincOnSelectionChange = (e) => {
    setVinculoSelecionado(e)
  }

  const onPerfil = (e) => {
    setPerfilSelect(e.value);
  }

  const alterarPerfil = () => {
    let jsonVinculoPerfil = vinculoSelecionado.map(element => {
      return {
        idenVinculo: element.idenVinculo,
        idenPerfilAcesso: perfilSelect.id
      }
    })

    alterarPerfilUsuario(jsonVinculoPerfil).then(res => {
      printToast({ summary: 'Sucesso', detail: "Operação concluída com sucesso" });
      setShowForm(false);
    })

  }

  return (
    <CardSeplag title="Usuário">
      <TableSeplag
        hasEventoAcao
        camposTabela={camposTabela}
        dados={ListaUsuario}
        onEditarDado={onEditarDado}
        onPage={paginacao}
        onSearch={onBuscaPorNomeCPF}
        totalRecords={totalRecords}
      />

      {
        showForm &&
        <ModalSeplag titulo='Perfis do Usuário' tamanho="50vw" type={'NONE'} visible={showForm} fechar={onFecharModal}>
          <div className='p-col-12'>
            <TabView className='tabview-cadastro'>
              <TabPanel header="Cadastro" rightIcon='pi pi-user-edit'>

                <div className="preenchimento-baixo">
                  <form style={{ marginTop: "5px" }} onSubmit={formik.handleSubmit} className="p-grid">
                    <RotuloSeplag nome="Nome" cols="12 6" >
                      <InputText type="text" value={form.pessoa.nomePessoa} placeholder="Nome" disabled />
                    </RotuloSeplag>
                    <RotuloSeplag nome="Nome Apresentação:" cols="12 6" >
                      <InputText type="text" value={form.pessoa.nomeApresentacao} placeholder="Nome Apresentação" disabled />
                    </RotuloSeplag>
                    <RotuloSeplag nome="Email" cols="12 6" >
                      <InputText type="text" value={form.pessoa.descEmail} placeholder="Email" disabled />
                    </RotuloSeplag>
                    <RotuloSeplag nome="Login" cols="12 6">
                      <InputText type="text" value={form.pessoa.Login} placeholder="Login" disabled />
                    </RotuloSeplag>
                    <RotuloSeplag nome="CPF" cols="12 6" >
                      <InputMask value={form.pessoa.numrCpf} mask="999.999.999-99" placeholder="999.999.999-99" disabled />
                    </RotuloSeplag>
                    <RotuloSeplag nome="Matrícula" cols="12 6">
                      <InputText type="text" value={form.pessoa.numrMatricula} placeholder="Matrícula" disabled />
                    </RotuloSeplag>
                    <RotuloSeplag nome="Telefone Pessoal" cols="12 6">
                      <InputMask value={form.pessoa.numrTelefoneCelular} mask="(99)99999999" placeholder="(99)99999-9999" disabled />
                    </RotuloSeplag>
                    <RotuloSeplag nome="Telefone Celular" cols="12 6">
                      <InputMask value={form.pessoa.numrTelefonePessoal} mask="(99)99999999?9" placeholder="(99)99999-9999" disabled />
                    </RotuloSeplag>
                  </form>
                </div>
              </TabPanel>

              <TabPanel header="Perfis de Acesso" rightIcon='pi pi-cog'>

                <div className="p-grid p-fluid">

                  <Panel header="Perfis de Acesso" className="p-col-12">
                    <Dropdown
                      value={perfilSelect}
                      options={perfisdeAcesso}
                      optionLabel="nomePerfilAcesso"
                      placeholder="Selecione um Perfil"
                      onChange={onPerfil}
                    />
                  </Panel>

                  <Panel header="Vínculos do usuário" className="p-col-12">
                    <TableSeplag
                      camposTabela={camposTabelaVinculo}
                      dados={cDadosVinculos}
                      semPaginacao
                      onSelectionChange={vincOnSelectionChange}
                      selectionMode="multiple"
                    />
                  </Panel>

                  <div className="p-col-12 p-md-4 p-md-offset-8" >
                    <Button
                      label="Aplicar"
                      icon="pi pi-check"
                      className="p-button-success"
                      disabled={!perfilSelect || vinculoSelecionado.length == 0}
                      onClick={alterarPerfil}
                    />
                  </div>

                </div>
              </TabPanel>
            </TabView>
          </div>
        </ModalSeplag>
      }

    </CardSeplag>

  )
};
export default Index;












